export default __webpack_public_path__ + "2b8f04aa3c66f8311e449f2108e27515.png";